import { render, staticRenderFns } from "./calendar-event-add.vue?vue&type=template&id=08e6d7a7&"
import script from "./calendar-event-add.vue?vue&type=script&lang=js&"
export * from "./calendar-event-add.vue?vue&type=script&lang=js&"
import style0 from "./calendar-event-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports